import { FC, useEffect } from "react";
import { useLocation } from "react-router-dom";

import { trackPageView } from "@utils/analytics";

/**
 * Fires a first-party page-view beacon on every route change (path only — no
 * query string / PII). Fire-and-forget; mounted once under the router.
 * See docu/flows/analytics/first-party-tracking.md.
 */
export const PageViewTracker: FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    trackPageView(pathname);
  }, [pathname]);

  return null;
};
